import {
  CommonErrorMessage,
  CommonPopupCrud,
  dateTimeFormat,
  MuiDataGrid,
} from "@common";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
// ==================================================================================================================

function getUpdatedByRole(value1, rowParam) {
  const row = rowParam || value1?.row || value1;
  const value = row?.user_role_data || row?.roleName || row?.role;
  if (!value) return "";
  if (typeof value === "string") return value;
  return `${value?.roleCode || ""}-${value?.roleName || ""}`;
}

function getUpdatedBy(value, rowParam) {
  const row = rowParam || value?.row || value;
  return (
    row?.user_updated?.email ||
    row?.user_created?.email ||
    row?.updatedBy?.email ||
    row?.createdBy?.email ||
    row?.email ||
    ""
  );
}

const CommonStatusHistory = ({ showUpdateByRole = true, ...props }) => {
  const reduxHistory = useSelector((state) => state?.statusHistory);
  const rawData = props?.data !== undefined ? props?.data : reduxHistory?.data;

  const rows = useMemo(() => {
    let list = rawData;
    if (list && typeof list === "object" && !Array.isArray(list)) {
      if (Array.isArray(list.data)) list = list.data;
      else if (Array.isArray(list.rows)) list = list.rows;
      else if (Array.isArray(list.result)) list = list.result;
      else list = [];
    }
    if (!Array.isArray(list)) return [];
    return list.map((item, index) => ({
      id: item?.id ?? item?._id ?? (index + 1),
      ...item,
    }));
  }, [rawData]);

  const columns = useMemo(() => {
    return [
      {
        field: "status",
        headerName: "Status",
        renderHeader: () => <strong>Status</strong>,
        width: 200,
        valueGetter: (value, rowParam) => {
          const row = rowParam || value?.row || value;
          return row?.status || row?.toStatus || row?.newStatus || row?.statusName || value || "-";
        },
      },
      showUpdateByRole && {
        field: "updatedByRole",
        headerName: "Updated By Role",
        renderHeader: () => <strong>Updated By Role</strong>,
        width: 180,
        valueGetter: getUpdatedByRole,
      },
      {
        field: "updatedBy",
        headerName: "Updated By",
        renderHeader: () => <strong>Updated By</strong>,
        width: 290,
        valueGetter: getUpdatedBy,
      },
      {
        field: "updatedOn",
        headerName: "Updated On",
        renderHeader: () => <strong>Updated On</strong>,
        valueGetter: (value, rowParam) => {
          const row = rowParam || value?.row || value;
          const date = row?.updatedOn || row?.createdOn || row?.createdAt || row?.timestamp;
          return date ? dateTimeFormat(date) : "-";
        },
        width: 270,
      },
    ].filter(Boolean);
  }, [showUpdateByRole]);

  const StatusHistorydata = useMemo(
    () => ({
      rows,
      columns,
    }),
    [rows, columns],
  );

  try {
    return (
      <CommonPopupCrud
        largeScreen={true}
        close={props.close}
        heading="Status History"
        buttonAlignRight={true}
        cancelButtonName="Close"
      >
        <MuiDataGrid data={StatusHistorydata} customHeight="60vh" />
      </CommonPopupCrud>
    );
  } catch (err) {
    console.error("CommonStatusHistory Error:", err);
    return <CommonErrorMessage />;
  }
};

CommonStatusHistory.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  loading: PropTypes.bool,
  close: PropTypes.func.isRequired,
  showUpdateByRole: PropTypes.bool,
};

export default CommonStatusHistory;
